import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppService } from './app.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AppResolver implements Resolve<any> {

	constructor(private appService: AppService, private translate: TranslateService){}

	resolve(router: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		return this.appService.loadAppData(router.paramMap.get('domainId'));
	}
}
